import type { OptionFC } from './interface';

const Option: OptionFC = () => null;
Option.isSelectOption = true;
Option.displayName = 'AAutoCompleteOption';
export default Option;
